import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    rules: {},
    loaded: {}
  }
};

export function exclusions(data) {
  if (!data) {
    return [];
  }

  return data.map(obj => ({
    assetKey: obj.asset_key,
    assetValue: obj.asset_value,
    consumerKey: obj.profile_key,
    consumerValue: obj.profile_value
  }));
}

export function classifiers(data) {
  if (!data) {
    return {};
  }

  const returnObj = {};

  if (data.length) {
    data.forEach(obj => {
      returnObj[obj.asset_key] = {
        consumerKey: obj.profile_key,
        mustMatch: obj.must_match || false,
        applyToFallback: obj.apply_to_fallback || false
      };
    });
  } else {
    return {};
  }

  return returnObj;
}

export function mergeRules(data) {
  if (data) {
    return {
      ...data,
      exclusion: exclusions(data.exclusion),
      classifier: classifiers(data.classifier)
    };
  }
  return {};
}

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_GET_RULES:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_GET_RULES:
    case Constants.RECEIVE_SAVE_RULES:
    case Constants.RECEIVE_SAVE_CONTINGENCY:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      const rules = mergeRules(action.data.rules);
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          rules,
          loaded: { ...rules }
        }
      };
    case Constants.REVERT_CLASSIFIER_RULES:
      return {
        ...state,
        data: {
          ...state.data,
          rules: {
            ...state.data.rules,
            classifier: state.data.loaded.classifier
          }
        }
      };
    case Constants.REVERT_EXCLUSION_RULES:
      return {
        ...state,
        data: {
          ...state.data,
          rules: {
            ...state.data.rules,
            exclusion: state.data.loaded.exclusion
          }
        }
      };
    case Constants.REVERT_FATIGUE_RULES:
      return {
        ...state,
        data: {
          ...state.data,
          rules: {
            ...state.data.rules,
            fatigue: state.data.loaded.fatigue
          }
        }
      };
    case Constants.REVERT_VARIETY_RULES:
      return {
        ...state,
        data: {
          ...state.data,
          rules: {
            ...state.data.rules,
            variety: state.data.loaded.variety
          }
        }
      };
    case Constants.UPDATE_RULES:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          rules: mergeRules(action.data.rules)
        }
      };
    default:
      return state;
  }
}
